import type { CommandServices } from '@wix/cli-command-contract';
import type { ProjectModel } from '../model.js';
import { authenticate } from '../authentication.js';
import { syncTypesWithAuth } from './sync-types-with-auth.js';

export async function syncTypes(
  model: ProjectModel,
  { biLogger, errorReporter }: CommandServices
) {
  const authState = await authenticate({
    metaSiteId: model.metaSiteId,
    biLogger,
    errorReporter,
  });

  return syncTypesWithAuth(model, { authState });
}
